const CategoryCardContainer = ({ children }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 justify-center w-full lg:w-[1000px] gap-4 mt-16">
            {children}
        </div>
    )
}

export default CategoryCardContainer